import { get, post, put, del } from '../client/axiosClient';
import { clientEndpoints } from '../endpoints/client.endpoints';
import { buildEndpointWithQuery } from '../endpoints/base.endpoints';
import type {
  ApiResponse, PaginatedResponse, EmptyResponse, ID,
  Client, CreateClientRequest, UpdateClientRequest, ClientSearchRequest,
} from '../types';

class ClientService {
  async getAll(params?: ClientSearchRequest): Promise<PaginatedResponse<Client>> {
    const endpoint = params
      ? buildEndpointWithQuery(clientEndpoints.basePath(), params as Record<string, any>)
      : clientEndpoints.list();
    const response = await get<any>(endpoint);
    const raw = response.data;
    const pagedResult = raw?.data ?? {};
    return {
      success: raw?.success ?? false,
      message: raw?.message,
      data: pagedResult.items ?? [],
      pagination: {
        currentPage: pagedResult.page ?? 1,
        pageSize: pagedResult.pageSize ?? 20,
        totalPages: pagedResult.totalPages ?? 0,
        totalItems: pagedResult.totalCount ?? 0,
        hasNextPage: pagedResult.hasNext ?? false,
        hasPreviousPage: pagedResult.hasPrevious ?? false,
      },
    };
  }

  async getById(id: ID): Promise<ApiResponse<Client>> {
    const response = await get<ApiResponse<Client>>(clientEndpoints.getById(id));
    return response.data;
  }

  async create(data: CreateClientRequest): Promise<ApiResponse<Client>> {
    const response = await post<ApiResponse<Client>>(clientEndpoints.create(), data);
    return response.data;
  }

  async update(id: ID, data: UpdateClientRequest): Promise<ApiResponse<Client>> {
    const response = await put<ApiResponse<Client>>(clientEndpoints.update(id), data);
    return response.data;
  }

  async delete(id: ID): Promise<EmptyResponse> {
    await del<void>(clientEndpoints.delete(id));
    return { success: true };
  }
}

export const clientService = new ClientService();
export default clientService;
